export enum pixelEventsEnum {
  ContractSignature = "Contract_Signature",
  OfferSelection = "Offer_Selection",
  RiskApproved = "Risk_Approved",
}
